import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'shared/lib/redux';

import { getManageOnboardingInvitesUrl } from './constants';
import {
  AcceptMyInviteQueryPayload,
  AcceptMyInviteResponse,
  ResponseMeta,
} from './types';

export const manageOnboardingInvitesApi = createApi({
  reducerPath: 'manage-onboarding-invites',
  baseQuery: baseQuery(getManageOnboardingInvitesUrl),
  endpoints: (builder) => ({
    acceptMyInvite: builder.query<
      AcceptMyInviteResponse,
      AcceptMyInviteQueryPayload
    >({
      query: (requestBody) => {
        return {
          url: 'my/invites/accept',
          method: 'PATCH',
          body: requestBody,
        };
      },
      transformResponse: (_, meta: ResponseMeta) => {
        return { responseCode: meta.response.status };
      },
      transformErrorResponse: (_, meta: ResponseMeta) => {
        return { responseCode: meta.response.status };
      },
    }),
  }),
});

export const { useAcceptMyInviteQuery } = manageOnboardingInvitesApi;
